import PropTypes from 'prop-types';
import { useState } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
// @mui
import { Box, List, ListItemText, TextField, InputAdornment } from '@mui/material';
//
import { StyledNavItem, StyledNavItemIcon } from './styles';
import Iconify from '../iconify';

// auth hook

import { useAuth } from '../../context/AuthContext';
// ----------------------------------------------------------------------




NavSection.propTypes = {
  data: PropTypes.array,
};

export default function NavSection({ data = [], ...other }) {
  const [searchTerm, setSearchTerm] = useState('');
  const { currentUser } = useAuth();

  const filteredData = data.filter(item => {
    const userRoles = Array.isArray(currentUser?.role) ? currentUser.role : [];
    const hasPermission = item.role.some(type => userRoles.some(userRole => userRole === type));
    const matchesSearch = item.title.toLowerCase().includes(searchTerm.toLowerCase());
    return hasPermission && matchesSearch;
  });

  return (
    <Box {...other}>
      <Box sx={{ p: 1, mb: 1 }}>
        <TextField
          size="small"
          placeholder="Buscar módulo..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <Box sx={{ 
        maxHeight: 'calc(100vh - 200px)', 
        overflow: 'auto', 
        px: 1,
        '&::-webkit-scrollbar': { display: 'none' },
        '-ms-overflow-style': 'none',
        'scrollbar-width': 'none'
      }}>
        <List disablePadding>
          {filteredData.map((item) => (
            <NavItem key={item.title} item={item} />
          ))}
        </List>
      </Box>
    </Box>
  );
}

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const { title, path, icon, info } = item;

  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
    >
      <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>

      <ListItemText 
        disableTypography 
        primary={title} 
        sx={{
          textTransform: "none",
          '& .MuiListItemText-primary': {
            fontSize: '0.875rem',
            fontWeight: 500,
          }
        }} 
      />

      {info && info}
    </StyledNavItem>
  );
}